import React, { useContext, useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';
import { motion, AnimatePresence } from 'framer-motion';
import { RiUser3Line, RiSmartphoneLine } from 'react-icons/ri';
import { useLocation } from 'react-router-dom'; 

import Header from '../topbotm/Header';
import Footer from '../topbotm/Footer';
import Sidebar from '../dashboard/sidebar';
import { AuthContext } from '../../context/authContext';

// Import your two client components here (ensure paths are correct)
import { Clientw } from './client_web'; 
import { AppClient } from './client_app'; 

import '../css/others/home.css';

export const Client = () => {
    // Default to the regular clients tab
    const [view, setView] = useState('regular');
    const location = useLocation();
    const { user } = useContext(AuthContext);

    useEffect(() => {
        if (location.state?.mountSection) {
            setView(location.state.mountSection);
            
            // Clear the state after reading it so a refresh 
            // doesn't keep forcing the tab if the user switches manually.
            window.history.replaceState({}, document.title);
        };
    }, [location.state]);
    
    // Define the two client types for your tabs
    const tabs = [
        { 
            id: 'regular', 
            label: 'Existing Clients', 
            icon: <RiUser3Line className="me-2" />,
            component: <Clientw /> 
        },
        { 
            id: 'app', 
            label: 'App Users', 
            icon: <RiSmartphoneLine className="me-2" />,
            component: <AppClient /> 
        }
    ];

    return (
        <div className="dashboard-page">
            <Header />
            <ToastContainer autoClose={3000} />

            <div className={`dashboard-wrapper`}>
                <div className='d-none' style={{backgroundColor:"#4a127e"}}>
                    <Sidebar user={user} />
                </div>

                <main className="main-area">
                    <Container fluid="xxl" className="py-4 px-3 px-md-5">
                        <motion.div 
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            className="main-glass-card shadow-lg"
                        >
                            <div className="custom-tab-header">
                                <div className="tabs-left-group">
                                    {tabs.map((tab) => (
                                        <button
                                            key={tab.id}
                                            className={`tab-btn d-flex align-items-center ${view === tab.id ? 'active' : ''}`}
                                            onClick={() => setView(tab.id)}
                                        >
                                            {tab.icon}
                                            {tab.label}
                                            {view === tab.id && (
                                                <motion.div 
                                                    layoutId="activeTab" 
                                                    className="active-underline" 
                                                />
                                            )}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <div className="content-body" style={{ padding: '0px' }}>
                                <AnimatePresence mode="wait">
                                    <motion.div
                                        key={view}
                                        initial={{ opacity: 0, x: 15 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        exit={{ opacity: 0, x: -15 }}
                                        transition={{ duration: 0.25 }}
                                    >
                                        {tabs.find(t => t.id === view)?.component}
                                    </motion.div>
                                </AnimatePresence>
                            </div>
                        </motion.div>
                    </Container>
                </main>
            </div>
            <Footer />
        </div>
    );
};